import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import { TOP_BAR_HEIGHT } from '../../../runtime/Navigation/Menu/Menu.styles';
import Theme, { fontStyles } from 'Theme';

const PADDING_VERTICAL = 14;
const PADDING_HORIZONTAL = 6;

const baseStyles = {
    container: {
        padding: Theme.primaryMargin
    },
    header: {
        ...fontStyles.settingsHeading,
        paddingVertical: PADDING_VERTICAL,
        paddingHorizontal: PADDING_HORIZONTAL
    },
    innerItemContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    itemName: {
        paddingVertical: PADDING_VERTICAL,
        paddingHorizontal: PADDING_HORIZONTAL,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Device.isTabletOrWeb ? 20 : 20
    },
    openIcon: {
        width: Theme.primaryFontSize,
        height: Theme.primaryFontSize
    }
};

export default StyleSheet.create(baseStyles);
